import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import Zone from "@insite/client-framework/Components/Zone";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps, IconProps } from "@insite/mobius/Icon";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Modal, { ModalProps } from "@insite/mobius/Modal";
import { RadioComponentProps, RadioProps } from "@insite/mobius/Radio";
import { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CENPasswordRequirement from "@tCentro/Components/CENPasswordRequirement";
import CustomEyeIcon from "@tCentro/Icons/CustomEyeIcon";
import CustomQuestionIcon from "@tCentro/Icons/CustomQuestionIcon";
import addAccount from "@tCentro/Store/Data/Accounts/Handlers/AddAccount";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { ReactNode, RefObject, useContext, useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

import { GridWrapper } from "@insite/mobius/GridContainer";
import Cookies from "js-cookie";
import FileUpload, { FileUploadPresentationProps } from "@insite/mobius/FileUpload";
import getFileExtension from "@insite/client-framework/Common/Utilities/getFileExtension";

const mapDispatchToProps = {
    addAccount,
    signIn,
    validatePassword,
    validateReCaptcha: makeHandlerChainAwaitable<
        { location: string; recaptchaRef: React.RefObject<ReCAPTCHA | null> },
        boolean
    >(validateReCaptcha),
};

const mapStateToProps = (state: ApplicationState) => ({
    accountSettings: getSettingsCollection(state).accountSettings,
    returnUrl: getCreateAccountReturnUrl(state),
    homePageUrl: getHomePageUrl(state),
    reCaptchaEnabledForCreateAccount: getSettingsCollection(state).websiteSettings.reCaptchaEnabledForCreateAccount,
});

const enum fields {
    image = "image",
    title = "title",
    topDescription = "topDescription",
    existingCustomerDescription = "existingCustomerDescription",
    modalDescription = "modalDescription",
    description = "description",
    modalHeading = "modalHeading",
    maxFileSize = "maxFileSize",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.title]: string;
        [fields.topDescription]: string;
        [fields.modalDescription]: string;
        [fields.modalHeading]: string;
        [fields.existingCustomerDescription]: string;
        [fields.description]: string;
         [fields.maxFileSize]: number;
    };
}
type Props = OwnProps &
    WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory;

export interface CreateAccountStyles {
    form?: InjectableCss;
    userGridItem?: GridItemProps;
    mainContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    customergridStyles?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    passwordIcon?: IconPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    customerTypeGridItem?: GridItemProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    radioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
    mainclass?: InjectableCss;
    passwordAndconfirmPassword?: InjectableCss;
    requirementsMobile?: InjectableCss;
    requirementstyle?: InjectableCss;
    stepsHeading?: TypographyProps;
    existingRadioButton?: FieldSetPresentationProps<RadioComponentProps>;
    customerNeedhelpStyles?: InjectableCss;
    customerNeedhelpStylesCustom?: InjectableCss;
    needHelpIconStyles?: IconProps;
    needHelpIconStylesCustom?: IconProps;
    modalStyles?: ModalProps;
    contentContainerStyles?: InjectableCss;
    contentStyles?: InjectableCss;
    headingStyles?: InjectableCss;
    paraStyles?: InjectableCss;
    modalbtnStyles?: InjectableCss;
    needHelpContentStyles?: InjectableCss;
    needHelpContentStylesCustom?: InjectableCss;
    textFieldStyles?: TextFieldPresentationProps;
    nameContainerStyles?: InjectableCss;
    checkboxStyles?: CheckboxProps;
    stepGridStyles?: GridItemProps;
    iconStyles?: IconProps;
    customerNumberMsgStyles?: InjectableCss;
    tooltipContainer?: InjectableCss;
    tooltipContainerCustom?: InjectableCss;
    tooltipTopContainer?: InjectableCss;
    tooltiprightContent?: InjectableCss;
    tooltipheading?: InjectableCss;
    backButtonStyles?: InjectableCss;
    topDescriptionStyles?: InjectableCss;
    existingAccountContainer?: InjectableCss;
    existingAccountContent?: InjectableCss;
    imgStyles?: InjectableCss;
    hiddenMobileStyles?: InjectableCss;
    hiddenDesktopStyles?: InjectableCss;
    hiddenDesktopStylesCustom?: InjectableCss;
    existingCustomer?: InjectableCss;
    mobileModalContentStyles?: InjectableCss;
    activationInstructionGridItem?: GridItemProps;
    activationInstructionText?: TypographyPresentationProps;
    activationSuccessWrapper?: InjectableCss;
    activationSuccessTitleText?: TypographyPresentationProps;
    activationSuccessMessageText?: TypographyPresentationProps;
    activationSuccessHomeButton?: ButtonPresentationProps;
    existingCustomerCheckbox?: CheckboxPresentationProps;
    existingCustomerCheckboxGridItem?: GridItemProps;
    postalCodedGridItem?: GridItemProps;
    wrapper?: InjectableCss;
    needFurtherParaStyle?: InjectableCss;
    linkStyleCustom?: InjectableCss;
    linkStyleCustomEMail?: InjectableCss;
    topDescriptionCustomStyles?: InjectableCss;
    checkboxGridItem?: GridItemProps;
    checkboxGridItemWithError?: GridItemProps;
    checkboxStyle?: InjectableCss;
    fileUploader?: FileUploadPresentationProps;
    fileUploaderContainer?: InjectableCss;
}

export const createAccountStyles: CreateAccountStyles = {
    fileUploader: {
        buttonProps: {
            variant: "secondary",
        },
    },
    checkboxStyle: {
        css: css`
            min-height: 22px;

            span[role="checkbox"] {
                &:focus {
                    box-shadow: none !important;
                }
                  
            }
          &[disabled] {
  opacity: 0.5;
           }
        

            margin-top: 20px;
            label {
                font-size: 18px !important;
                padding-left: 8px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 14px !important;
                        `,
                        css`
                            font-size: 14px !important;
                        `,
                        css``,
                        null,
                        null,
                    ])}

                font-weight: 600;
                font-size: 14px;
                color: ${getProp("theme.typography.p.color")} !important ;
            }
            span {
                width: 24px;
                height: 24px;
                border: 2px solid #262525 !important ;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css``,
                        null,
                        null,
                    ])}
            }
            svg {
                width: 24px;
                height: 24px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css``,
                        null,
                        null,
                    ])}
            }
        `,
    },
    checkboxGridItem: {
        width: 12,
        css: css`  
            max-width: 100%;
        flex-basis: 100%;
        gap:16px;
        align-items: flex-start;
        margin-top:20px !important;
        padding-bottom: 0px !important;
           flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                `,
                css`
                    flex-direction: column;
                `,
                css``,
                null,
                null,
            ])}
        label{
        margin-left: 0px !important;
        }
        button{
        margin-left:10px;
        }
        div[class^="UploadWrapper"]{
       
          ${({ theme }: { theme: BaseTheme }) =>
              breakpointMediaQueries(theme, [
                  css`
                      width: 100%;
                  `,
                  css`
                      width: 100%;
                  `,
                  css``,
                  null,
                  null,
              ])}
        align-items: center;
        div[class^="FormFieldStyle"]{
            width:330px;
            max-width: 330px;
             ${({ theme }: { theme: BaseTheme }) =>
                 breakpointMediaQueries(theme, [
                     css`
                         width: 100%;
                         max-width: 100%;
                     `,
                     css`
                         width: 100%;
                         max-width: 100%;
                     `,
                     css``,
                     null,
                     null,
                 ])}
        }
         div[class^="FileUploadStyle"]{ {
                    width: 100%;
                    box-sizing: border-box;
                    font-family: inherit;
                    font-size: 15px;
                    outline: 0px;
                    appearance: none;
                    color: inherit;
                    background-color: #f2f2f2 !important;
                    border-radius: 24px !important;
                    padding:0px 30px 0px 10px;
                }
                    div[class^="AppearanceTransition"]{
                    input{
                   height: 35px !important;
        margin-top: 2px;
         }
        button{
        height: 37px !important;
        margin-top: 1px;
        
        }
                    
                    }
        span[id^="orderUploadFileUpload-label"]{
        
         color: black !important;
        }
        }
        div[class^="ButtonWrapper"]{
        label[for^="orderUploadFileUpload"]{
        // padding: 0px 21px !important;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 50px;
                `,
                css`
                    margin-top: 50px;
                `,
                css``,
                null,
                null,
            ])};
        span{
        color: #8F0446;
        }
        }
    
        margin-left: 10px !important;
         label{
        
        //  margin-top: 0px !important;
        }
        }
       
        `,
    },
    checkboxGridItemWithError: {
        width: 12,
        css: css`  
            max-width: 100%;
        flex-basis: 100%;
        gap:16px;
        align-items: flex-start;
        margin-top:20px !important;;
        padding-bottom: 0px !important;
          flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                `,
                css`
                    flex-direction: column;
                `,
                css``,
                null,
                null,
            ])}
        label{
        margin-left: 0px !important;
        margin-top:0px !important;
        }
        button{
        margin-left:10px;
        }
        div[class^="UploadWrapper"]{
       
          ${({ theme }: { theme: BaseTheme }) =>
              breakpointMediaQueries(theme, [
                  css`
                      width: 100%;
                  `,
                  css`
                      width: 100%;
                  `,
                  css``,
                  null,
                  null,
              ])};
        align-items: center;
        max-width:500px !important;
        width: 500px;
         div[class^="FileUploadStyle"]{ 
         {
                    width: 100%;
                    box-sizing: border-box;
                    font-family: inherit;
                    font-size: 15px;
                    outline: 0px;
                    appearance: none;
                    color: inherit;
                    background-color: #f2f2f2 !important;
                    border-radius: 24px !important;
                    padding: 0px 10px;
                   
                }
                    input[id="orderUploadFileUpload"]{
                   padding-right: 55px !important;
                   } 
                    div[class^="AppearanceTransition"]{
                    input{
                   height: 35px !important;
        margin-top: 2px;
         }
        button{
        height: 37px !important;
        margin-top: 1px;
        
        }
                    
                    }
        span[id^="orderUploadFileUpload-label"]{
        
        //  display: none;
        }
        }
        div[class^="ButtonWrapper"]{
        label[for^="orderUploadFileUpload"]{
            margin-top: 0px !important;
        span{
        color: #8F0446;
        }
        }
    
        margin-left: 10px !important;
         label{
        
        //  margin-top: 0px !important;
        }
        }
       
        `,
    },
    needFurtherParaStyle: {
        css: css`
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
        `,
    },
    linkStyleCustom: {
        css: css`
            span {
                color: #000000 !important;
                font-weight: 600;
            }
        `,
    },
    linkStyleCustomEMail: {
        css: css`
            span {
                font-weight: 600;
            }
        `,
    },
    activationInstructionGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 50px;
                        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    existingCustomerCheckboxGridItem: {
        width: 12,
        css: css`
            margin-top: 40px !important;
            span[role="checkbox"] {
                border: 2px solid #262525 !important;
                &:focus {
                    box-shadow: none !important;
                }
            }
            span[role="checkbox"][aria-checked="true"][aria-disabled="false"] {
                border: 2px solid ${COLORS.black} !important;
            }
            span {
                width: 24px !important;
                height: 24px;
                border: 1px solid ${getProp("theme.typography.p.color")} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css``,
                        null,
                        null,
                    ])}

                svg {
                    width: 24px !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                width: 20px !important;
                            `,
                            css`
                                width: 20px !important;
                            `,
                            css``,
                            null,
                            null,
                        ])}
                }
            }
            label {
                font-weight: 600;
                font-size: 18px;
                color: ${getProp("theme.typography.p.color")} !important ;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 14px;
                        `,
                        css`
                            font-size: 14px;
                        `,
                        css``,
                        null,
                        null,
                    ])}
            }
        `,
    },
    activationSuccessWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            width: 50%;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    activationSuccessTitleText: {
        variant: "h3",
    },
    activationSuccessHomeButton: {
        css: css`
            align-self: flex-end;
        `,
    },
    mobileModalContentStyles: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            text-align: left;
            margin-top: 24px;
        `,
    },
    hiddenDesktopStyles: {
        css: css`
            display: flex;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            margin-top: 4px;
            margin-left: 5px;
        `,
    },
    hiddenDesktopStylesCustom: {
        css: css`
            display: flex;
        `,
    },
    existingCustomer: {
        css: css`
            display: flex;
        `,
    },
    hiddenMobileStyles: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                    `,
                    css`
                        margin-top: 8px;
                    `,
                    css`
                        margin-top: 8px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    tooltipTopContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `,
    },
    tooltiprightContent: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    tooltipheading: {
        css: css`
            font-size: 32px !important;
            font-style: normal !important;
            font-weight: 700 !important;
            line-height: 40px !important;
            color: ${getProp("theme.typography.p.color")} !important;
            padding: 0px 10px 10px 10px !important;
        `,
    },
    modalStyles: {
        size: 640,
        cssOverrides: {
            modalTitle: css`
                border: none !important;
            `,
            modalBody: css`
                @media screen and (min-width: 1025px) {
                    display: none !important;
                }
                @media screen and (max-width: 1024px) {
                    display: block !important;
                }
            `,
        },
    },
    existingAccountContent: {
        css: css`
            padding-right: 10px;
            color: ${getColor("text.main")};
            p {
                font-family: Poppins;
                font-size: 18px;
                font-weight: 700;
                line-height: 24px;
                text-align: left;
                // color: ${getColor("secondary")};
            }
        `,
    },
    existingAccountContainer: {
        css: css`
            padding: 24px;
            background: #eef3f0;
            margin-top: 40px;

            label {
                font-family: Poppins;
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;
                margin-left: 10px;
                color: ${getColor("accent.contrast")};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        max-width: 58%;
                    `,
                    css`
                        max-width: 58%;
                    `,
                ])};
            @media (min-width: 993px) and (max-width: 1300px) {
                max-width: 80%;
            }
        `,
    },
    requirementstyle: {
        css: css`
            margin-top: 32px;
        `,
    },
    topDescriptionStyles: {
        css: css`
            grid-column: span 9;
            margin-top: 24px;
            margin-bottom: 24px;
            font-family: Poppins;
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            text-align: left;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    backButtonStyles: {
        css: css`
            margin-left: 15px;
            padding: 12px 24px;
            border-radius: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        margin-left: 0px;
                        margin-top: 10px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    customerNumberMsgStyles: {
        css: css`
            font-size: 12px;
            font-style: italic;
            font-weight: 400;
            line-height: 16px;
            margin-top: 8px;
            width: 85%;
        `,
    },
    iconStyles: {
        css: css`
            position: relative;
            right: 15px;
        `,
    },
    submitButton: {
        css: css`
            width: auto;
            padding: 12px 24px;
            border-radius: 24px;
            min-height: 48px !important;
        `,
    },

    checkboxStyles: {
        css: css`
            > label {
                margin-top: 4px;
            }
                >span{
            > svg {
                height: 20px;
                width: 20px;
            }
    }
        `,
    },
    textFieldStyles: {
        border: "rounded",
        css: css`
            div[class^="DescriptionWrapper"] {
                margin-left: 10px !important;
            }
        `,
        cssOverrides: {
            inputSelect: css`
                background-color: #f2f2f2;
                border: none;
                &.textFieldWhite {
                    background-color: white;
                }
                border-radius: 24px;
                &:focus {
                    border-radius: 24px !important;
                }
                &::placeholder {
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 24px;
                }
            `,
            formInputWrapper: css`
                width: 100%;

                @media (max-width: 1200px) {
                    max-width: none;
                    width: auto;
                    height: auto;
                }
                > input {
                    border-radius: 24px !important;
                }
            `,
        },
    },

    nameContainerStyles: {
        css: css`
            display: flex;
            gap: 24px;
            margin-top: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    needHelpIconStyles: {
        size: 14,
        css: css`
            svg {
                position: relative;
                top: 4px;
            }
        `,
    },
    needHelpIconStylesCustom: {
        css: css``,
    },
    contentContainerStyles: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    contentStyles: {
        css: css`
            margin-left: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                        margin-left: 0px;
                    `,
                    css`
                        text-align: center;
                        margin-left: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    headingStyles: {
        css: css`
            font-family: Poppins;
            font-size: ${TYPOGRAPHY.size.xxlarge};
            font-weight: ${TYPOGRAPHY.weight.bold};
            line-height: 40px;
            text-align: left;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                        font-size: 24px;
                        line-height: 32px;
                        margin-top: 24px;
                    `,
                    css`
                        text-align: center;
                        margin-top: 24px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    paraStyles: {
        css: css`
            font-family: Poppins;
            font-size: 14px !important;
            font-weight: 400 !important;
            line-height: 20px;
            margin-top: 24px;
            padding: 0px !important;
        `,
    },
    needHelpContentStyles: {
        css: css`
            position: absolute;
            right: 72px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 18px;
                        left: 240px;
                        width: max-content;
                    `,
                    css`
                        top: 18px;
                        left: 240px;
                        width: max-content;
                    `,
                    null,
                    null,
                    null,
                ])}

            @media (min-width: 1300px) and (max-width: 1430px) {
                right: 25px !important;
            }
        `,
    },
    topDescriptionCustomStyles: {
        css: css`
            display: grid;
            grid-template-columns: repeat(12, 1fr);
        `,
    },
    needHelpContentStylesCustom: {
        css: css`
            position: absolute;
            // right: 65px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            // z-index:9999;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        top: 18px;
                        left: 240px;
                        width: max-content;
                    `,
                    css`
                        top: 18px;
                        left: 240px;
                        width: max-content;
                    `,
                    null,
                    null,
                    null,
                ])}

            @media (min-width: 1300px) and (max-width: 1430px) {
                right: 25px !important;
            }
        `,
    },

    customerNeedhelpStyles: {
        css: css`
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            color: ${getColor("text.link")};
            margin-left: 4px;
            cursor: pointer;
        `,
    },
    customerNeedhelpStylesCustom: {
        css: css`
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
            color: ${getColor("text.link")};
            padding-left: 10px;
            cursor: pointer;
            display: flex;
            justify-content: flex-end;
        `,
    },
    imgStyles: {
        css: css`
            max-width: 224px;
            max-height: 224px;
            aspect-ratio: 1/1;
        `,
    },
    customergridStyles: {
        width: [12, 12, 6, 6, 6],
        css: css`
            position: relative;
            max-width: 394px !important;
            width: 100%;
            flex-direction: column;
        `,
    },
    mainclass: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },

    passwordAndconfirmPassword: {
        css: css`
            display: flex;
            gap: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    userGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            margin-top: 48px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 24px !important;
                    `,
                    css`
                        margin-top: 24px !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mainContainer: {
        css: css`
            label {
                font-family: Poppins;
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;

                margin-left: 10px;
            }
        `,
    },
    emailGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            padding-top: 4px;
            max-width: 394px !important;
            width: 100%;
        `,
    },
    userNameGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    stepGridStyles: {
        width: [12, 12, 12, 12, 12],
    },
    passwordGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            max-width: 394px !important;
            width: 100%;
        `,
    },
    postalCodedGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            max-width: 394px !important;
            width: 100%;
            flex-direction: column;
        `,
    },
    confirmPasswordGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            max-width: 394px !important;
            width: 100%;
        `,
    },
    subscriptionGridItem: {
        width: 12,
        css: css`
            div {
                legend {
                    margin-bottom: 0px;
                }
            }
            div[data-test-selector^="createAccount_Subscription"] {
                align-items: flex-start !important;
            }
            span[role="checkbox"] {
                border: 2px solid #262525 !important;
                border-radius: 4 !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css`
                            width: 20px !important;
                            height: 20px;
                        `,
                        css``,
                        null,
                        null,
                    ])}
                width:24px;
                height: 24px;
                margin-top: 4px;
                &:focus {
                    box-shadow: none !important;
                }
                &[aria-checked="true"] {
                    background: none !important;
                    color: ${getProp("theme.typography.p.color")} !important;
                    border: 2px solid ${COLORS.black} !important;
                }
            }
            span[role="checkbox"] + label {
                color: ${getProp("theme.typography.p.color")};
                font-family: Poppins;
                font-size: 18px;
                font-weight: 600;
                line-height: 16px;
                text-align: left;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 14px;
                        `,
                        css`
                            font-size: 14px;
                        `,
                        css``,
                        null,
                        null,
                    ])}
            }
            margin-top: 8px !important;
        `,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    reCaptchaGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            p{
                        color: rgb(226, 57, 57) !important;
                        
            }
            
        `,
    },
    submitGridItem: {
        css: css`
            margin-bottom: 40px;
            margin-top: 14px;
        `,
    },
    customerTypeGridItem: {
        width: 12,
        css: css`
            display: block !important;
            padding-top: 3px !important;
            fieldset {
                display: flex;
                div {
                    margin: 0px;
                    margin-right: 6px;
                    input {
                        display: block !important;
                        margin: 0;
                        padding: 0;
                        height: 0;
                    }
                    input:focus + label::before {
                        box-shadow: none !important;
                    }
                    label {
                        margin-left: 0px;
                        & ::before {
                            margin-right: 11px;
                            width: 18px;
                            height: 18px;
                        }

                        & ::after {
                            left: 6px !important;
                        }
                    }
                }
            }
        `,
    },
    tooltipContainer: {
        css: css`
            width: 100%;
            background-color: white;
            box-shadow: 0px 12px 24px 0px rgba(38, 37, 37, 0.24);
            position: absolute;
            bottom: 100%;
            left: 0%;
            z-index: 999;
            padding: 40px;
            display: none;
            &:before {
                content: "";
                z-index: 999;
                position: absolute;
                margin-left: -60px;
                top: 92%;
                left: 50%;
                width: 0px;
                height: 0px;
                border-top: 42px solid #fff;
                border-right: 42px solid transparent;
                border-left: 42px solid transparent;
                background-color: transparent;

                @media (min-width: 993px) and (max-width: 1300px) {
                    right: -29px;
                    border-top: 26px solid transparent;
                    border-bottom: 26px solid transparent;
                    border-left: 30px solid #fff;
                    background: transparent;
                    border-right: 0px;
                    top: 110px;
                }
            }
            @media (min-width: 993px) and (max-width: 1300px) {
                left: -300px;
                width: 60vw;
            }
            @media screen and (min-width: 992px) {
                display: flex !important;
                .tooltip {
                    display: flex;
                    flex-direction: column;
                }
                .tooltipWrapper {
                    display: flex;
                    flex-direction: row;
                    gap: 24px;
                }
            }
            @media screen and (max-width: 991px) {
                display: none !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 80vw;
                        left: 0px;
                        top: 90px;
                    `,
                    css`
                        width: 80vw;
                        left: 0px;
                        top: 90px;
                    `,
                    css`
                        width: 80vw;
                        left: 0px;
                        top: 90px;
                    `,
                    null,
                    null,
                ])}

            width:41.17vw;
        `,
    },
    tooltipContainerCustom: {
        css: css`
            width: 100%;
            background-color: white;
            box-shadow: 0px 12px 24px 0px rgba(38, 37, 37, 0.24);
            position: absolute;
            bottom: 143%;
            left: -200%;
            z-index: 999;
            padding: 40px;
            display: none;
            &:before {
                content: "";
                z-index: 999;
                position: absolute;
                margin-left: -60px;
                top: 91%;
                left: 50%;
                width: 0px;
                height: 0px;
                border-top: 42px solid #fff;
                border-right: 42px solid transparent;
                border-left: 42px solid transparent;
                background-color: transparent;

                @media (min-width: 993px) and (max-width: 1300px) {
                    right: -29px;
                    border-top: 26px solid transparent;
                    border-bottom: 26px solid transparent;
                    border-left: 30px solid #fff;
                    background: transparent;
                    border-right: 0px;
                    top: 110px;
                }
            }
            @media (min-width: 993px) and (max-width: 1300px) {
                left: -300px;
                width: 60vw;
            }
            @media screen and (min-width: 992px) {
                display: flex !important;
                .tooltip {
                    display: flex;
                    flex-direction: column;
                }
                .tooltipWrapper {
                    display: flex;
                    flex-direction: row;
                    gap: 24px;
                }
            }
            @media screen and (max-width: 991px) {
                display: none !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 80vw;
                        left: 0px;
                        top: 90px;
                    `,
                    css`
                        width: 80vw;
                        left: 0px;
                        top: 90px;
                    `,
                    css`
                        width: 80vw;
                        left: 0px;
                        top: 90px;
                    `,
                    null,
                    null,
                ])}

            width:41.17vw;
        `,
    },
};

const styles = createAccountStyles;
const emailRegexp = /^[\w.+'-]+@[\w.-]+\.(?!c0m$|cim$|con$|c0n$|usa$)[A-Za-z]{2,}$/i;
const StyledForm = getStyledWrapper("form");

const CreateAccount = ({
    addAccount,
    signIn,
    validatePassword,
    validateReCaptcha,
    accountSettings,
    returnUrl,
    fields,
    history,
    homePageUrl,
    reCaptchaEnabledForCreateAccount,
    id,
}: Props) => {
    const uploadFileMessageEPA = siteMessage("Tax Exemption Certificate Required");
    const existingCustomerPostalCodeMessage = siteMessage("Create_Account_Existing_Customer_Postal_Code");
    const existingCustomerNumberMessage = siteMessage("Create_Account_Existing_Customer_Customer_Number");
    const userNameRequiredFieldMessage = siteMessage("CreateNewAccountInfo_UserName_Required");
    const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
    const firstNameMessage = siteMessage("CreateNewAccountInfo_FirstName_Required");
    const lastNameMessage = siteMessage("CreateNewAccountInfo_LastName_Required");
    const passwordFielderrorMessage = siteMessage("CreateNewAccountInfo_Password_Required");
    const confirmPasswordFielderrorMessage = siteMessage("CreateNewAccountInfo_confirmPassword_Required");
    const customerNumberBillToMessage = siteMessage("customer_number_billTo_message");
    const postalCodeMessage = siteMessage("postal_code_message");
    const customerNumberFielderrorMessage = siteMessage("CreateNewAccountInfo_CustomerNumber_Required");
    const postalCodeFielderrorMessage = siteMessage("CreateNewAccountInfo_PostalCode_Required");
    const [email, setEmail] = useState("");
    const [userName, setUserName] = useState("");
    const [userNameError, setUserNameError] = useState(
        accountSettings.useEmailAsUserName ? "" : userNameRequiredFieldMessage,
    );
    const [errorMessage, setErrorMessage] = useState("");
    const [password, setPassword] = useState("");
    const [passwordErrorMessage, setPasswordErrorMessage] = useState<ReactNode>(passwordFielderrorMessage);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = useState<ReactNode>(
        confirmPasswordFielderrorMessage,
    );
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isActivationEmailSent, setIsActivationEmailSent] = useState(false);
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [firstNameError, setFirstNameError] = useState(firstNameMessage);
    const [lastNameError, setLastNameError] = useState(lastNameMessage);
    const toasterContext = useContext(ToasterContext);
    const recaptchaRef: React.RefObject<ReCAPTCHA | null> = React.createRef();

    const [isExistingCustomer, setIsExistingCustomer] = useState("false");
    const [customerNumber, setCustomerNumber] = useState("");
    const [postalCode, setpostalCode] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [formType, setFormType] = React.useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenCustom, setIsModalOpenCustom] = useState(false);
    const [showCustomerDetails, setShowCustomerDetails] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredCustom, setIsHoveredCustom] = useState(false);
    const [customerNumberError, setCustomerNumberError] = useState<ReactNode>(customerNumberFielderrorMessage);
    const [postalCodeError, setpostalCodeError] = useState<ReactNode>(postalCodeFielderrorMessage);
    const [fileEPA, setFileEPA] = useState<any>(null);
    const [taxExemptValue, setTaxExemptValue] = useState(false);
    const [isTaxExempt, setIsTaxExempt] = useState("false");
    const fileUploadRef = useRef({ value: "" } as HTMLInputElement);
    const [FileUploadEPAerror, setFileUploadEPAerror] =  useState<ReactNode>(uploadFileMessageEPA);

    const checkboxGridItemFinal =
        (fileEPA && !!FileUploadEPAerror) || (!fileEPA && FileUploadEPAerror === uploadFileMessageEPA && isSubmitted)
            ? { ...styles.checkboxGridItemWithError }
            : { ...styles.checkboxGridItem };

    const handleTaxExemptionCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        setTaxExemptValue(value);
        if (value) {
            setIsTaxExempt("true");
            setFileUploadEPAerror(uploadFileMessageEPA);
        } else {
            setIsTaxExempt("false");
            setFileUploadEPAerror("");
        }
    };
    const handleCheckboxChange: CheckboxProps["onChange"] = (_, value) => {
        setShowCustomerDetails(value);
        if (value) {
            setIsExistingCustomer("true");
            setFormType("existingCentroCustomer");
            setCustomerNumberError(customerNumberFielderrorMessage);
            setpostalCodeError(postalCodeFielderrorMessage);
             setIsTaxExempt("false");
            setFileUploadEPAerror("");
             setFileEPA("");
        } else {
            setIsExistingCustomer("false");
            setFormType("newCentroCustomer");
            setCustomerNumber("");
            setpostalCode("");
            setCustomerNumberError("");
            setpostalCodeError("");
        }
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const handleMouseEnterCustom = () => {
        setIsHoveredCustom(true);
    };

    const handleMouseLeaveCustom = () => {
        setIsHoveredCustom(false);
    };
    const validateCustomerNumber = (customerNumberError: string) => {
        const CustomerNumber =
            !customerNumberError && customerNumberError.length <= 0 ? customerNumberFielderrorMessage : "";
        setCustomerNumberError(CustomerNumber);
        return !CustomerNumber;
    };
    const customerNumberHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCustomerNumber(event.target.value);
        validateCustomerNumber(event.target.value);
    };
    const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setpostalCode(event.target.value);
        validatepostalCode(event.target.value);
    };
    const firstNameHandler = (firstName: string) => {
        setFirstName(firstName);
        validateFirstName(firstName);
    };
    const lastNameHandler = (lastName: string) => {
        setLastName(lastName);
        validateLastName(lastName);
    };

    const {
        passwordMinimumLength,
        passwordRequiresUppercase,
        passwordRequiresSpecialCharacter,
        passwordRequiresLowercase,
        passwordRequiresDigit,
        useEmailAsUserName,
        requireActivateAccount,
    } = accountSettings;

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validateUserName = (name: string) => {
        const errorMessage = !name && !useEmailAsUserName ? userNameRequiredFieldMessage : "";
        setUserNameError(errorMessage);
        return !errorMessage;
    };

    const validateFirstName = (firstName: string) => {
        const firstError = !firstName && firstName.length <= 0 ? firstNameMessage : "";
        setFirstNameError(firstError);
        return !firstError;
    };

    const validateLastName = (lastName: string) => {
        const lastError = !lastName && lastName.length <= 0 ? lastNameMessage : "";
        setLastNameError(lastError);
        return !lastError;
    };

    const validatepostalCode = (postalCodeError: string) => {
        const numericOnly = translate("Please Enter only Number");
        const checkifNumber = Boolean(Number(postalCodeError));
        const NumberErrors =
            !checkifNumber && postalCodeError.length > 0
                ? numericOnly
                : !postalCodeError
                  ? postalCodeFielderrorMessage
                  : "";

        setpostalCodeError(NumberErrors);
        return !NumberErrors;
    };

    const validateConfirmPassword = (newPassword: string, newConfirmPassword: string) => {
        const errorMessage =
            newPassword !== newConfirmPassword
                ? siteMessage("CreateNewAccountInfo_PasswordCombination_DoesNotMatch")
                : "";
        setConfirmPasswordErrorMessage(errorMessage);
        return !errorMessage;
    };

    const validateSubmitEnabled = () => {
        const commonErrors =
            emailError ||
            passwordErrorMessage ||
            confirmPasswordErrorMessage ||
            userNameError ||
            firstNameError ||
            lastNameError;
        return !(
            commonErrors ||
            (showCustomerDetails ? (customerNumberError || postalCodeError):"") ||
            (taxExemptValue ? FileUploadEPAerror :"")
        );
       
    };

    const emailChangeHandler = (email: string) => {
        validateEmail(email);
        setEmail(email);
    };

    const userChangeHandler = (name: string) => {
        validateUserName(name);
        setUserName(name);
    };

    const passwordChangeHandler = (newPassword: string) => {
        validateConfirmPassword(newPassword, confirmPassword);
        validatePassword({
            password: newPassword,
            onComplete: errorMessage => {
                setPasswordErrorMessage(errorMessage);
            },
        });
        setPassword(newPassword);
    };

    const confirmPasswordChangeHandler = (newConfirmPassword: string) => {
        setConfirmPassword(newConfirmPassword);
        validateConfirmPassword(password, newConfirmPassword);
    };

    const onSuccessHandler = (account?: AccountModel) => {
        setErrorMessage("");
        toasterContext.addToast({ body: translate("Account created successfully!"), messageType: "success" });
        Cookies.set("hasLoggedInBefore", "true", { expires: 365 });
        if (account?.activationStatus === "Activated") {
            setTimeout(() => {
                signIn({
                    userName: useEmailAsUserName ? email : userName,
                    password,
                    rememberMe: false,
                    returnUrl,
                });
            }, 500);
        } else {
            setIsActivationEmailSent(true);
        }
    };
    const toBase64 = (file: File): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const result = reader.result as string;
                const base64 = result.split(",")[1];
                resolve(base64);
            };
            reader.onerror = error => reject(error);
        });

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            return;
        }

        const isReCaptchaValid = await validateReCaptcha({ location: "CreateAccount", recaptchaRef });
        if (!isReCaptchaValid) {
            return;
        }

        function getDataLayer() {
            return (window as any).dataLayer;
        }
        if (formType === "existingCentroCustomer") {
            const dataLayer = getDataLayer();
            if (dataLayer) {
                dataLayer.push({
                    event: `ExistingCustomer`,
                });
            }
        } else if (formType === "previouslyPurchasedCustomer" || formType === "newCentroCustomer") {
            const dataLayer = getDataLayer();
            if (dataLayer) {
                dataLayer.push({
                    event: `NewCustomer`,
                });
            }
        }
        let pdfBase64 = "";
        if (fileEPA) {
            pdfBase64 = await toBase64(fileEPA);
        }

        setIsSubmitting(true);
        addAccount({
            email,
            userName,
            password,
            isSubscribed,
            firstName,
            lastName,
            uri: "",
            properties: {
                isExistingCustomer,
                customerNumber,
                postalCode,
                IsTaxExempt: isTaxExempt,
                TaxCertificate: pdfBase64,
            },
            onSuccess: onSuccessHandler,
            onError: error => {
                setErrorMessage(error);
                setIsSubmitting(false);
            },
            onComplete(resultProps) {
                setIsSubmitting(false);
                if (resultProps.apiResult?.successful) {
                    // "this" is targeting the object being created, not the parent SFC
                     
                    this.onSuccess?.(resultProps.apiResult.result);
                } else if (resultProps.apiResult?.errorMessage) {
                    // "this" is targeting the object being created, not the parent SFC
                     
                    this.onError?.(resultProps.apiResult.errorMessage);
                }
            },
        });
    };

    const homeClickHandler = () => {
        history.push(homePageUrl);
    };

    if (isActivationEmailSent) {
        return (
            <StyledWrapper {...styles.activationSuccessWrapper}>
                <Typography as="h2" {...styles.activationSuccessTitleText}>
                    {translate("Check your email")}
                </Typography>
                <Typography {...styles.activationSuccessMessageText}>
                    {siteMessage("CreateNewAccountInfo_AccountActivation_SuccessMessage")}
                </Typography>
                <Button
                    {...styles.activationSuccessHomeButton}
                    onClick={homeClickHandler}
                    data-test-selector="createAccount_BackToHomePage"
                >
                    {translate("Home")}
                </Button>
            </StyledWrapper>
        );
    }

    const isSubmitEnabled = validateSubmitEnabled();

    const openModalHandler = () => {
        setIsModalOpen(true);
    };
    const openModalHandlerCustom = () => {
        setIsModalOpenCustom(true);
    };
    const modalCloseHandler = () => setIsModalOpen(false);
    const modalCloseHandlerCustom = () => setIsModalOpenCustom(false);
    const fileChangeHandlerEPA = (event: React.ChangeEvent<any>) => {
        const uploadedFiles = event.target.files?.[0];
        if (uploadedFiles) {
            validateUploadedFileEPA(uploadedFiles);
            setFileEPA(uploadedFiles);
        } else {
            validateUploadedFileEPA("");
            setFileEPA("");
        }
    };
    const validateUploadedFileEPA = (file: any) => {
        const fileExtension = file ? getFileExtension(file.name) : "";
        const allowedExtensions = ["pdf"];
        const incorrectFileExtension = file && !allowedExtensions.includes(fileExtension);
        const maxFileSizeMB = fields.maxFileSize; // Maximum file size in MB
        const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;
        const fileTooLarge = file && file.size > maxFileSizeBytes;

        const FileUploadEPAerror = !file
            ? uploadFileMessageEPA
            : incorrectFileExtension
              ? translate("File must be .pdf format")
              : fileTooLarge
                ? siteMessage("FileSize_Error")
                : "";

        setFileUploadEPAerror(FileUploadEPAerror);
        return !FileUploadEPAerror;
    };
    const registerFormId = `${siteMessage("Create_Account_Register_Form_Id")}`;
    return (
        <LoadingOverlay
            loading={
                isSubmitting ||
                (isSubmitted &&
                    !isSubmitEnabled &&
                    !(
                        errorMessage ||
                        emailError ||
                        userNameError ||
                        passwordErrorMessage ||
                        confirmPasswordErrorMessage ||
                        firstNameError ||
                        lastNameError ||
                        (showCustomerDetails && (customerNumberError || postalCodeError))||
                        (taxExemptValue && (FileUploadEPAerror))
                    ))
            }
            css={css`
                width: 100%;
                position: fixed !important;
                top: 0px;
                left: 0px;
            `}
        >
            <StyledForm {...styles.form} onSubmit={submitHandler} noValidate id={registerFormId}>
                <GridWrapper {...styles.topDescriptionCustomStyles}>
                    <Typography as="p" {...styles.topDescriptionStyles}>
                        {fields.topDescription}
                    </Typography>
                </GridWrapper>
                <StyledWrapper {...styles.mainContainer}>
                    <StyledWrapper>
                        <GridItem {...styles.emailGridItem}>
                            <TextField
                                {...styles.textFieldStyles}
                                type="email"
                                label={translate("Email Address")}
                                onChange={e => emailChangeHandler(e.currentTarget.value)}
                                value={email}
                                data-test-selector="createAccount_email"
                                maxLength={256}
                                required
                                error={isSubmitted && emailError}
                                autoComplete="off"
                            />
                        </GridItem>
                        <StyledWrapper {...styles.nameContainerStyles}>
                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.textFieldStyles}
                                    label={translate("First Name")}
                                    value={firstName}
                                    data-test-selector="createAccount_userName"
                                    onChange={e => firstNameHandler(e.currentTarget.value)}
                                    error={isSubmitted && firstNameError}
                                    maxLength={256}
                                    required
                                    autoComplete="off"
                                />
                            </GridItem>
                            <GridItem {...styles.emailGridItem}>
                                <TextField
                                    {...styles.textFieldStyles}
                                    label={translate("Last Name")}
                                    value={lastName}
                                    data-test-selector="createAccount_userName"
                                    onChange={e => lastNameHandler(e.currentTarget.value)}
                                    error={isSubmitted && lastNameError}
                                    required
                                    autoComplete="off"
                                />
                            </GridItem>
                        </StyledWrapper>

                        {!useEmailAsUserName && (
                            <GridItem {...styles.userNameGridItem}>
                                <TextField
                                    {...styles.textFieldStyles}
                                    label={translate("User Name")}
                                    value={userName}
                                    data-test-selector="createAccount_userName"
                                    onChange={e => userChangeHandler(e.currentTarget.value)}
                                    error={isSubmitted && userNameError}
                                    required
                                    autoComplete="off"
                                    placeholder="User Name"
                                />
                            </GridItem>
                        )}

                        <StyledWrapper {...styles.mainclass}>
                            {!requireActivateAccount && (
                                <StyledWrapper {...styles.nameContainerStyles}>
                                    <GridItem {...styles.passwordGridItem}>
                                        <TextField
                                            id="password"
                                            {...styles.textFieldStyles}
                                            type={showPassword ? undefined : "password"}
                                            label={translate("Password")}
                                            value={password}
                                            onChange={e => passwordChangeHandler(e.currentTarget.value)}
                                            error={isSubmitted && passwordErrorMessage}
                                            iconProps={{
                                                ...styles.passwordIcon,
                                                src: showPassword ? EyeOff : CustomEyeIcon,
                                            }}
                                            iconClickableProps={{
                                                onClick: () => {
                                                    setShowPassword(!showPassword);
                                                },
                                                type: "button",
                                            }}
                                            clickableText={password}
                                            data-test-selector="createAccount_password"
                                            required
                                            // placeholder="Password"
                                            autoComplete="off"
                                        />
                                    </GridItem>
                                    <GridItem {...styles.confirmPasswordGridItem}>
                                        <TextField
                                            id="confirm-password"
                                            {...styles.textFieldStyles}
                                            type={showConfirmPassword ? undefined : "password"}
                                            label={translate("Confirm Password")}
                                            value={confirmPassword}
                                            onChange={e => confirmPasswordChangeHandler(e.currentTarget.value)}
                                            error={isSubmitted && confirmPasswordErrorMessage}
                                            iconProps={{
                                                ...styles.confirmPasswordIcon,
                                                src: showConfirmPassword ? EyeOff : CustomEyeIcon,
                                            }}
                                            iconClickableProps={{
                                                onClick: () => {
                                                    setShowConfirmPassword(!showConfirmPassword);
                                                },
                                                type: "button",
                                            }}
                                            clickableText={confirmPassword}
                                            data-test-selector="createAccount_confirmPassword"
                                            required
                                            // placeholder="Confirm Password"
                                            autoComplete="off"
                                        />
                                    </GridItem>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                <GridItem {...styles.existingCustomerCheckboxGridItem}>
                    <Checkbox
                        checked={showCustomerDetails}
                        onChange={handleCheckboxChange}
                        {...styles.existingCustomerCheckbox}
                    >
                        {siteMessage("Existing_Account_Message")}
                    </Checkbox>
                </GridItem>

                {showCustomerDetails && (
                    <StyledWrapper {...styles.existingAccountContainer}>
                        <StyledWrapper {...styles.existingCustomer}>
                            <Typography {...styles.existingAccountContent} as="p">
                                {parse(transformContentHtml(fields.existingCustomerDescription), parserOptions)}
                            </Typography>
                        </StyledWrapper>

                        <GridContainer
                            css={css`
                                margin-top: 24px;
                            `}
                        >
                            <GridItem {...styles.postalCodedGridItem}>
                                <TextField
                                    {...styles.textFieldStyles}
                                    label={existingCustomerPostalCodeMessage}
                                    value={postalCode}
                                    onChange={postalCodeHandler}
                                    error={isSubmitted && postalCodeError}
                                    required={showCustomerDetails}
                                    // placeholder="Enter Postal Code"
                                    className="textFieldWhite"
                                    autoComplete="new-postalCode"
                                />
                                <StyledWrapper {...styles.customerNumberMsgStyles}>{postalCodeMessage}</StyledWrapper>
                            </GridItem>

                            <GridItem {...styles.customergridStyles}>
                                <TextField
                                    {...styles.textFieldStyles}
                                    label={existingCustomerNumberMessage}
                                    value={customerNumber}
                                    onChange={customerNumberHandler}
                                    error={isSubmitted && customerNumberError}
                                    required={showCustomerDetails}
                                    // placeholder="Enter Customer Number"
                                    className="textFieldWhite"
                                    autoComplete="new-customerNumber"
                                />
                                <Hidden above="md" {...styles.hiddenMobileStyles}>
                                    <CustomQuestionIcon {...styles.needHelpIconStyles} />
                                    <Typography as="span" {...styles.customerNeedhelpStyles} onClick={openModalHandler}>
                                        {translate("What's This1")}
                                    </Typography>
                                </Hidden>
                                <StyledWrapper {...styles.needHelpContentStyles}>
                                    <Hidden below="lg" {...styles.hiddenDesktopStyles}>
                                        <CustomQuestionIcon {...styles.needHelpIconStyles} />
                                        <Typography
                                            as="span"
                                            {...styles.customerNeedhelpStyles}
                                            onMouseEnter={handleMouseEnter}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            {translate("What's This")}
                                        </Typography>
                                    </Hidden>
                                </StyledWrapper>
                                <StyledWrapper {...styles.customerNumberMsgStyles}>
                                    {customerNumberBillToMessage}
                                </StyledWrapper>
                                {isHovered && (
                                    <StyledWrapper {...styles.tooltipContainer}>
                                        <StyledWrapper className="tooltip">
                                            <StyledWrapper className="tooltipWrapper">
                                                <StyledWrapper className="mainwrapper">
                                                    <Img
                                                        src={fields.image}
                                                        altText={fields.modalHeading}
                                                        {...styles.imgStyles}
                                                    />
                                                </StyledWrapper>
                                                <StyledWrapper {...styles.tooltipTopContainer}>
                                                    <StyledWrapper {...styles.tooltiprightContent}>
                                                        <Typography as="p" {...styles.tooltipheading}>
                                                            {fields.modalHeading}
                                                        </Typography>
                                                    </StyledWrapper>
                                                    <Typography as="p" {...styles.paraStyles}>
                                                        {fields.modalDescription}
                                                    </Typography>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                            <Typography as="p" {...styles.paraStyles}>
                                                {parse(transformContentHtml(fields.description), parserOptions)}
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}

                                <Modal isOpen={isModalOpen} handleClose={modalCloseHandler} {...styles.modalStyles}>
                                    <StyledWrapper {...styles.contentContainerStyles}>
                                        <Img src={fields.image} altText={fields.modalHeading} {...styles.imgStyles} />
                                        <StyledWrapper {...styles.contentStyles}>
                                            <Typography as="p" {...styles.headingStyles}>
                                                {fields.modalHeading}
                                            </Typography>

                                            <Typography as="p" {...styles.mobileModalContentStyles}>
                                                {fields.modalDescription}
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    <Typography as="p" {...styles.mobileModalContentStyles}>
                                        {parse(transformContentHtml(fields.description), parserOptions)}
                                    </Typography>
                                </Modal>
                                <Modal
                                    isOpen={isModalOpenCustom}
                                    handleClose={modalCloseHandlerCustom}
                                    {...styles.modalStyles}
                                >
                                    <StyledWrapper {...styles.contentContainerStyles}>
                                        <Img src={fields.image} altText={fields.modalHeading} {...styles.imgStyles} />
                                        <StyledWrapper {...styles.contentStyles}>
                                            <Typography as="p" {...styles.headingStyles}>
                                                {fields.modalHeading}
                                            </Typography>

                                            <Typography as="p" {...styles.mobileModalContentStyles}>
                                                {fields.modalDescription}
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    <Typography as="p" {...styles.mobileModalContentStyles}>
                                        {parse(transformContentHtml(fields.description), parserOptions)}
                                    </Typography>
                                </Modal>
                            </GridItem>
                            <Typography {...styles.existingAccountContent}>
                                <Zone contentId={id} zoneName="Content" />
                            </Typography>
                        </GridContainer>
                    </StyledWrapper>
                )}
                <GridItem {...checkboxGridItemFinal}>
                    <Checkbox
                        // onChange={() => setIsTaxExempt(!isTaxExempt)}
                        onChange={handleTaxExemptionCheckboxChange}
                        checked={taxExemptValue}
                        disabled={showCustomerDetails}
                        {...styles.checkboxStyle}
                    >
                        {translate("Tax Exempt")}
                    </Checkbox>

                    {(taxExemptValue && !showCustomerDetails )&& (
                        <StyledWrapper {...styles.fileUploaderContainer}>
                            <FileUpload
                                {...styles.fileUploader}
                                inputRef={fileUploadRef}
                                fileName={fileEPA?.name || ""}
                                accept=".pdf"
                                label={translate("Attach Tax Exemption Certificate")}
                                labelPosition="top"
                                error={(fileEPA || isSubmitted) && FileUploadEPAerror}
                                onFileChange={fileChangeHandlerEPA}
                                uid="orderUploadFileUpload"
                            />
                            {!fileEPA && (
                                <Typography>{siteMessage("UploadFile_Message", `${fields.maxFileSize}`)}</Typography>
                            )}
                        </StyledWrapper>
                    )}
                </GridItem>
                <StyledWrapper
                    css={css`
                        margin-top: 40px;
                    `}
                >
                    {reCaptchaEnabledForCreateAccount && (
                        <GridItem {...styles.reCaptchaGridItem}>
                            <ReCaptcha recaptchaRef={recaptchaRef} location="CreateAccount" />
                        </GridItem>
                    )}
                    <GridItem {...styles.subscriptionGridItem}>
                        <CheckboxGroup>
                            <Checkbox
                                {...styles.checkboxStyles}
                                onChange={(e, value) => setIsSubscribed(value)}
                                checked={isSubscribed}
                                data-test-selector="createAccount_Subscription"
                            >
                                {siteMessage("SignIn_Sign_Up_Newsletter")}
                            </Checkbox>
                        </CheckboxGroup>
                    </GridItem>
                    {errorMessage && (
                        <GridItem data-test-selector="createAccount_ErrorMessage" {...styles.submitErrorGridItem}>
                            <Typography {...styles.submitErrorTitle}>{errorMessage}</Typography>
                        </GridItem>
                    )}

                    <StyledWrapper {...styles.submitGridItem}>
                        <Button
                            {...styles.submitButton}
                            type="submit"
                            disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
                            data-test-selector="createAccount_createButton"
                        >
                            {translate("Create web account")}
                        </Button>
                    </StyledWrapper>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="Content2" />
                    </StyledWrapper>
                </StyledWrapper>
            </StyledForm>
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(CreateAccount)),
    definition: {
        allowedContexts: ["CreateAccountPage"],
        group: "Create Account",
        displayName: "CEN Create Account",
        fieldDefinitions: [
            {
                name: fields.topDescription,
                fieldType: "General",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                displayName: "Description",
            },
            {
                name: fields.existingCustomerDescription,
                fieldType: "General",
                editorTemplate: "RichTextField",
                defaultValue: "",
                displayName: "Existing Customer Description",
            },
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Modal Image",
            },
            {
                name: fields.modalHeading,
                fieldType: "General",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                displayName: "Modal Heading",
            },
            {
                name: fields.modalDescription,
                fieldType: "General",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                displayName: "Modal Description",
            },
            {
                name: fields.description,
                fieldType: "General",
                editorTemplate: "RichTextField",
                defaultValue: "",
                displayName: "Description",
            },
             {
                fieldType: "Contextual",
                name: fields.maxFileSize,
                editorTemplate: "TextField",
                displayName: "Max File Size",
                defaultValue: "5",
            },
        ],
    },
};

export default widgetModule;
